import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Dashboard from "@/pages/home/page";
import ReservationsPage from "@/pages/rezervasyonlar/page";
import CalendarPage from "@/pages/takvim/page";
import CustomersPage from "@/pages/musteriler/page";
import CheckInOutPage from "@/pages/giris-cikis/page";
import RoomsPage from "@/pages/odalar/page";
import PaymentsPage from "@/pages/odemeler/page";
import SourcesPage from "@/pages/kaynaklar/page";
import OffersPage from "@/pages/teklifler/page";
import TasksPage from "@/pages/gorevler/page";
import ReportsPage from "@/pages/raporlar/page";
import SettingsPage from "@/pages/ayarlar/page";
import Placeholder from "@/pages/Placeholder";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "/rezervasyonlar", element: <ReservationsPage /> },
      { path: "/takvim", element: <CalendarPage /> },
      { path: "/musteriler", element: <CustomersPage /> },
      { path: "/giris-cikis", element: <CheckInOutPage /> },
      { path: "/odalar", element: <RoomsPage /> },
      { path: "/odemeler", element: <PaymentsPage /> },
      { path: "/kaynaklar", element: <SourcesPage /> },
      { path: "/teklifler", element: <OffersPage /> },
      { path: "/gorevler", element: <TasksPage /> },
      { path: "/raporlar", element: <ReportsPage /> },
      { path: "/ayarlar", element: <SettingsPage /> },
    ],
  },
  { path: "*", element: <Placeholder title="Sayfa Bulunamadı" /> },
];

export default routes;